export default __webpack_public_path__ + "static/media/Will of Salvation.c2500915.jpg";